import { Outlet } from 'react-router'

import { UserHydrator } from '@/components/user-hydrator'
import { CompanyProvider } from '@/contexts/company'

import { CompanyParamRouteGuard } from './guards/company-param'

export function RoutesRootWrapper() {
  return (
    <CompanyParamRouteGuard>
      <CompanyProvider>
        <UserHydrator>
          <Outlet />
        </UserHydrator>
      </CompanyProvider>
    </CompanyParamRouteGuard>
  )
}
